// pages/FAQ/styles.js
import styled from "styled-components";

export const FAQWrapper = styled.div`
	min-height: calc(100vh - 72px);
	margin-top: 72px;
	background: ${(props) => props.theme.colors.background.alt};
`;

export const FAQHeader = styled.div`
	background: ${(props) => props.theme.colors.background.paper};
	padding: ${(props) => props.theme.spacing["3xl"]} 0;
	margin-bottom: ${(props) => props.theme.spacing["3xl"]};
	text-align: center;
	border-bottom: 1px solid ${(props) => props.theme.colors.border};

	h1 {
		font-size: ${(props) => props.theme.typography.sizes["4xl"]};
		color: ${(props) => props.theme.colors.text.primary};
		margin-bottom: ${(props) => props.theme.spacing.md};

		@media (max-width: ${(props) => props.theme.breakpoints.md}) {
			font-size: ${(props) => props.theme.typography.sizes["3xl"]};
		}
	}

	p {
		color: ${(props) => props.theme.colors.text.secondary};
		margin-bottom: ${(props) => props.theme.spacing.xl};
	}
`;

export const SearchContainer = styled.div`
	max-width: 600px;
	margin: 0 auto;
	position: relative;

	svg {
		position: absolute;
		left: ${(props) => props.theme.spacing.lg};
		top: 50%;
		transform: translateY(-50%);
		color: ${(props) => props.theme.colors.text.secondary};
	}
`;

export const SearchInput = styled.input`
	width: 100%;
	padding: ${(props) => props.theme.spacing.lg}
		${(props) => props.theme.spacing.lg} ${(props) => props.theme.spacing.lg}
		${(props) => props.theme.spacing["3xl"]};
	border: 1px solid ${(props) => props.theme.colors.border};
	border-radius: ${(props) => props.theme.borderRadius.full};
	font-size: ${(props) => props.theme.typography.sizes.lg};
	transition: all ${(props) => props.theme.transitions.normal};

	&:focus {
		outline: none;
		border-color: ${(props) => props.theme.colors.primary.main};
		box-shadow: 0 0 0 2px ${(props) => props.theme.colors.primary.main}20;
	}

	&::placeholder {
		color: ${(props) => props.theme.colors.text.disabled};
	}

	@media (max-width: ${(props) => props.theme.breakpoints.md}) {
		font-size: ${(props) => props.theme.typography.sizes.md};
	}
`;

export const FAQContent = styled.div`
	max-width: 800px;
	margin: 0 auto;
	padding: ${(props) => props.theme.spacing.xl};
	background: ${(props) => props.theme.colors.background.paper};
	border-radius: ${(props) => props.theme.borderRadius.lg};
	margin-bottom: ${(props) => props.theme.spacing["3xl"]};

	.no-results {
		text-align: center;
		padding: ${(props) => props.theme.spacing.xl};
		color: ${(props) => props.theme.colors.text.secondary};
	}
`;

export const CategorySection = styled.div`

	margin-bottom: ${(props) => props.theme.spacing["2xl"]};

	&:last-child {
		margin-bottom: 0;
	}

	h2 {
		font-size: ${(props) => props.theme.typography.sizes["2xl"]};
		color: ${(props) => props.theme.colors.text.primary};
		margin-bottom: ${(props) => props.theme.spacing.xl};
		padding-bottom: ${(props) => props.theme.spacing.md};
		border-bottom: 1px solid ${(props) => props.theme.colors.border};

		@media (max-width: ${(props) => props.theme.breakpoints.md}) {
			font-size: ${(props) => props.theme.typography.sizes.xl};
		}
	}
`;

export const QuestionAccordion = styled.div`
	margin-bottom: ${(props) => props.theme.spacing.md};
	border: 1px solid ${(props) => props.theme.colors.border};
	border-radius: ${(props) => props.theme.borderRadius.md};
	overflow: hidden;

	&:last-child {
		margin-bottom: 25px;
	}
`;

export const AccordionHeader = styled.button`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: ${(props) => props.theme.spacing.lg};
	background: ${(props) =>
		props.isExpanded ? props.theme.colors.primary.main + "10" : "transparent"};
	border: none;
	cursor: pointer;
	transition: all ${(props) => props.theme.transitions.normal};

	h3 {
		font-size: ${(props) => props.theme.typography.sizes.lg};
		font-weight: ${(props) => props.theme.typography.weights.medium};
		color: ${(props) =>
			props.isExpanded
				? props.theme.colors.primary.main
				: props.theme.colors.text.primary};
		text-align: left;
		margin: 0;

		@media (max-width: ${(props) => props.theme.breakpoints.md}) {
			font-size: ${(props) => props.theme.typography.sizes.md};
		}
	}

	svg {
		color: ${(props) =>
			props.isExpanded
				? props.theme.colors.primary.main
				: props.theme.colors.text.secondary};
		flex-shrink: 0;
		margin-left: ${(props) => props.theme.spacing.md};
	}

	&:hover {
		background: ${(props) => props.theme.colors.primary.main}10;

		h3 {
			color: ${(props) => props.theme.colors.primary.main};
		}

		svg {
			color: ${(props) => props.theme.colors.primary.main};
		}
	}
`;

export const AccordionContent = styled.div`
	padding: ${(props) => (props.isExpanded ? props.theme.spacing.lg : "0")};
	max-height: ${(props) => (props.isExpanded ? "500px" : "0")};
	opacity: ${(props) => (props.isExpanded ? "1" : "0")};
	overflow: hidden;
	transition: all ${(props) => props.theme.transitions.normal};
	border-top: ${(props) =>
		props.isExpanded ? `1px solid ${props.theme.colors.border}` : "none"};
	background: ${(props) => props.theme.colors.background.alt};

	p {
		color: ${(props) => props.theme.colors.text.secondary};
		line-height: 1.6;
		margin: 0;
	}
`;
